import * as wjcSheet from '@grapecity/wijmo.grid.sheet';

import { UnitOperationFlexSheetEventHandler } from './unit-operation-flex-sheet-event-handler';
import { OffshoreSource } from '../../../_models/_unit-operations/offshore-source';
import { enumValuesToArray } from '../../../_utils/enum-values-to-array';
import { NumberToSimulationVariableMapper } from '../mappers/number-to-simulation-variable-mapper';
import { OffshoreSourceCellConfig, OffshoreSourceSheetRows } from '../cell-config/offshore-source-cell-config';
import { FlexSheetValueConverter } from '../flex-sheet-value-converter';
import { OffshoreSourceFlexSheetMapper } from '../mappers/offshore-source-flex-sheet-mapper';

export class OffshoreSourceFlexSheetEventHandler implements UnitOperationFlexSheetEventHandler {
  constructor(private valueConverter: FlexSheetValueConverter) {}

  handle(unitOperation: OffshoreSource, spreadsheet: wjcSheet.FlexSheet, flexSheetEvent, rawValue) {
    const { row } = flexSheetEvent;

    if (enumValuesToArray(OffshoreSourceSheetRows).indexOf(row) === -1) {
      flexSheetEvent.cancel = true;
      return;
    }

    const cellConfig = OffshoreSourceCellConfig.find(rowConfig => rowConfig.row === row);
    const convertedValue = this.valueConverter.convert(spreadsheet, rawValue, cellConfig);

    const simulationVariableMapper = new NumberToSimulationVariableMapper();
    const mapper = new OffshoreSourceFlexSheetMapper(simulationVariableMapper);

    mapper.map(unitOperation, row, convertedValue);
  }
}
